import { MeetingMemberPreferences, NameListMode } from '../services/meetingService';
import { t } from '../i18n/translate';

export interface PreferenceSummaryLine {
  label: string;
  value: string;
}

export function nameListSummaryLine(mode: NameListMode): PreferenceSummaryLine {
  const label = t('workshop.2026.preferences.summary.name_label');
  switch (mode) {
    case 'now':
      return { label, value: t('workshop.2026.preferences.summary.name_now') };
    case 'when_workshop_starts':
      return { label, value: t('workshop.2026.preferences.summary.name_at_start') };
    default:
      return { label, value: t('workshop.2026.preferences.summary.name_never') };
  }
}

export function phoneListSummaryLine(
  preferences: MeetingMemberPreferences,
  profilePhone?: string
): PreferenceSummaryLine {
  const label = t('workshop.2026.preferences.summary.phone_label');
  if (!preferences.include_on_printed_phone_list) {
    return { label, value: t('workshop.2026.preferences.no') };
  }
  const phone = profilePhone?.trim();
  return {
    label,
    value: phone || t('workshop.2026.preferences.summary.add_number'),
  };
}

export function emailListSummaryLine(
  preferences: MeetingMemberPreferences,
  userEmail?: string
): PreferenceSummaryLine {
  const label = t('workshop.2026.preferences.summary.email_label');
  if (!preferences.include_email_on_list) {
    return { label, value: t('workshop.2026.preferences.no') };
  }
  const email = userEmail?.trim();
  return { label, value: email || t('workshop.2026.preferences.yes') };
}

export function sponsorSummaryLine(
  preferences: MeetingMemberPreferences
): PreferenceSummaryLine {
  const label = t('workshop.2026.preferences.summary.sponsor_label');
  switch (preferences.sponsor_willingness) {
    case 'yes':
      return { label, value: t('workshop.2026.preferences.yes') };
    case 'temporary':
      return { label, value: t('workshop.2026.preferences.summary.temporary') };
    default:
      return { label, value: t('workshop.2026.preferences.no') };
  }
}

export function preferencesCardSubtitle(
  preferences: MeetingMemberPreferences,
  profilePhone?: string
): string {
  let contact: string;
  const hasEmail = preferences.include_email_on_list;
  const hasPhone = preferences.include_on_printed_phone_list;
  if (!hasEmail && !hasPhone) {
    contact = t('workshop.2026.preferences.summary.no_contact');
  } else if (hasEmail && hasPhone) {
    contact = t('workshop.2026.preferences.summary.sharing_both');
  } else if (hasEmail) {
    contact = t('workshop.2026.preferences.summary.sharing_email');
  } else if (profilePhone?.trim()) {
    contact = t('workshop.2026.preferences.summary.sharing_phone');
  } else {
    contact = t('workshop.2026.preferences.summary.sharing_phone_add');
  }

  let name: string;
  switch (preferences.name_list_mode) {
    case 'now':
      name = t('workshop.2026.preferences.summary.name_now_frag');
      break;
    case 'when_workshop_starts':
      name = t('workshop.2026.preferences.summary.name_start_frag');
      break;
    default:
      name = t('workshop.2026.preferences.summary.name_not_listed');
  }

  let sentence = `${contact}; ${name}`;

  if (preferences.sponsor_willingness === 'yes') {
    sentence += `; ${t('workshop.2026.preferences.summary.open_sponsor')}`;
  } else if (preferences.sponsor_willingness === 'temporary') {
    sentence += `; ${t('workshop.2026.preferences.summary.temp_sponsor')}`;
  }

  return `${sentence.charAt(0).toUpperCase()}${sentence.slice(1)}.`;
}
